<nav class="subnav">
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/persons/overview']">Übersicht</a>
    </li>
  </ul>
</nav>

<main *ngIf="!!persons">
  <h2>PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Personen</h2>
  <clr-datagrid [clrDgLoading]="loading">
    <clr-dg-column [clrDgField]="'lastname'" [clrDgSortOrder]="descSort">Name</clr-dg-column>
    <clr-dg-column [clrDgField]="'company_name'">Firma</clr-dg-column>
    <clr-dg-column [clrDgField]="'phone'">Telefon</clr-dg-column>
    <clr-dg-column [clrDgField]="'mobile'">Mobil</clr-dg-column>
    <clr-dg-column [clrDgField]="'email'">E-Mail</clr-dg-column>
    <!--<clr-dg-column></clr-dg-column>-->
    <clr-dg-placeholder>We couldn't find any Persons!</clr-dg-placeholder>
    <clr-dg-row *clrDgItems="let person of persons" [routerLink]="['/person/details', person.pid ]">
      <clr-dg-cell>
        <b>{{ person.lastname }}</b>, {{ person.firstname }}
        <button *ngIf="!person.active" class="btn btn-warning btn-sm">PASSIV!</button>
      </clr-dg-cell>
      <clr-dg-cell>{{ person.company_name }}</clr-dg-cell>
      <clr-dg-cell>{{ person.phone }}</clr-dg-cell>
      <clr-dg-cell>{{ person.mobile }}</clr-dg-cell>
      <clr-dg-cell>{{ person.email }}</clr-dg-cell>
    </clr-dg-row>
    <clr-dg-footer>
      <clr-dg-pagination #pagination [clrDgPageSize]="50">
        <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Personen pro Seite</clr-dg-page-size>
        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
        von {{persons.length}} Person(en)

      </clr-dg-pagination>
    </clr-dg-footer>
  </clr-datagrid>
</main>
